import type { HelpFile } from '../../types/help'
import { ConnectorTestDialogTestIds } from '../../../testids/ConnectorTestDialogTestIds'

export const connectorTestDialogHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorTestDialogTestIds.btnCloseTestResult]: null,
  },
}
